import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07ef4409"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "abs-wrap flex"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "body"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 1,
  class: "nodata"
}



export default /*#__PURE__*/_defineComponent({
  props: [
  'columns',
  'data',
  'headClass',
  'itemClass',
  'rowKey',
  'border',
  'divide'
],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["table-like rel", { border: __props.border }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["head flex-ter rel", __props.headClass])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (v) => {
        return (_openBlock(), _createElementBlock("div", {
          key: v.label,
          class: _normalizeClass(["text-ct cell", { 'fx-1': !v.width, 'text-lf': v.left }]),
          style: _normalizeStyle({ width: v.width + 'px' })
        }, _toDisplayString(typeof v.fix === 'function' ? v.fix(v.label) : v.label), 7))
      }), 128)),
      (__props.divide)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (v, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: v.label,
                class: _normalizeClass({ 'fx-1': !v.width, s1: i > 0 }),
                style: _normalizeStyle({ width: v.width + 'px' })
              }, _hoisted_3, 6))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (__props.data.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item[__props.rowKey]
            }, [
              _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ item }))),
              _createElementVNode("div", {
                class: _normalizeClass(["flex-ter", __props.itemClass])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (v, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: v.label || i,
                    class: _normalizeClass(["text-ct cell", { 'fx-1': !v.width, 'text-lf': v.left }]),
                    style: _normalizeStyle({ width: v.width + 'px' })
                  }, [
                    (v.slotName)
                      ? _renderSlot(_ctx.$slots, v.slotName, _normalizeProps(_mergeProps({ key: 0 }, { item, index })))
                      : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(v.pipe ? v.pipe(item[v.prop], item) : item[v.prop]), 1))
                  ], 6))
                }), 128))
              ], 2)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "noData")
        ]))
  ], 2))
}
}

})